<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        billStsOptions: [], // 账单状态
        form: [
          { // 订单号码
            label: '订单号码',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号码',
            default: this.$route.query.orderId,
          },
          { // 账单号码
            label: '账单号码',
            value: 'billNumber',
            type: 'input',
            placeholder: '请输入账单号码',
            default: this.$route.query.billNumber,
          },
          { // 对账名称
            label: '对账名称',
            value: 'customName',
            type: 'input',
            placeholder: '请输入对账名称',
          },
          { // 账单状态
            label: '账单状态',
            value: 'billSts',
            type: 'select',
            default: -1,
            placeholder: '请选择账单状态',
          },
          { // 创建人
            label: '创建人',
            value: 'creatorName',
            type: 'input',
            placeholder: '请输入创建人',
          },
        ],
      },
    };
  },
  watch: {
    '$route.query.orderId': function (newVal) {
      if (this.$route.path === '/manage/getPay/customer/bill') {
        this.$refs.searchBox.setVal('orderId', newVal);
        this.$refs.searchBox.sub();
      }
    },
    '$route.query.billNumber': function (newVal) {
      if (this.$route.path === '/manage/getPay/customer/bill') {
        this.$refs.searchBox.setVal('billNumber', newVal);
        this.$refs.searchBox.sub();
      }
    },
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 发车时间
      if (searchBoxData.Time) {
        searchBoxData.beginTime = this.formatDate(searchBoxData.Time[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1]);
        delete searchBoxData.Time;
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'BILL_STS',
    });
    this.searchBoxData.billStsOptions = [ // 账单状态
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
